import styled from 'styled-components';

import {
  Flex,
} from 'web-styled';

export const Video = styled(Flex).attrs({
  column: true,
  flex: '0 0 334px',
})`
  overflow: hidden;
  background-color: #fafafa;
`;

export const Preview = styled(Flex).attrs({
  spacing: 10,
  column: true,
  align: 'center',
  justify: 'center',
})`
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: left center;
`;

export const Frame = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  background: none;
`;

export const PlayIcon = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
})`
  cursor: pointer;
  height: 44px;
  width: 44px;
  background-color: rgba(255,255,255,0.7);
  border-radius: 44px;
  overflow: hidden;
  svg {
    width: 15px;
    height: 15px;
  }
`;
